import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import ResizeConnectorItemCommand from './resizeConnectorItemCommand';

/**
 * Resize item command
 *
 * @class ResizeItemCommand
 * @extends AbstractCommand
 */
export default class MoveConnectorItemCommand extends ResizeConnectorItemCommand {
    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        return 'Move Connector';
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.MoveConnectorItemCommand = MoveConnectorItemCommand;
